const Messages = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 0 24 24"
            fill={color}
        >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1.88 14h-1.5l-.38-2H9.5a.75.75 0 0 1 0-1.5H11.75l-.5-2.5H9a.75.75 0 0 1 0-1.5h2l.38-2h1.5l-.38 2H15a.75.75 0 0 1 0 1.5h-2.75l.5 2.5H15a.75.75 0 0 1 0 1.5h-1.5l.38 2Z" />
        </svg>
    );
};

export default Messages;
